import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-tpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-tpams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationDetailsTpamsConstants } from "./view-application-details-tpams.constants";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { AlertType } from "../../../../shared/models/alert";
import { TownplanningService } from "../../../../shared/services/modules/townplanning.service";
import { mapTpApplicationTypeLimitToUiState, normalizeTpApplicationTypeLimit } from "../../../../shared/utils/tp-application-type-limit.utils";
let ViewApplicationDetailsTpamsComponent = class ViewApplicationDetailsTpamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    appController;
    townPlanningService;
    changeDetectorRef;
    routerParamsService;
    detailsForm;
    descriptionFormControlName = ViewApplicationDetailsTpamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    amendmentSchemeNumberFormControlName = ViewApplicationDetailsTpamsConstants.AMENDMENT_SCHEME_NUMBER_FORM_CONTROL_NAME;
    applicationTypesFormControlName = ViewApplicationDetailsTpamsConstants.APPLICATION_TYPES_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsTpamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    zonesFormControlName = ViewApplicationDetailsTpamsConstants.ZONES_FORM_CONTROL_NAME;
    zoneFormControlName = ViewApplicationDetailsTpamsConstants.ZONE_FORM_CONTROL_NAME;
    previousReferenceNumberFormControlName = ViewApplicationDetailsTpamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    isResubmissionFormControlName = ViewApplicationDetailsTpamsConstants.IS_RESUBMISSION_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    addZoneLabel = ViewApplicationDetailsTpamsConstants.ADD_ZONE_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    applicationTypeLabel = ViewApplicationDetailsTpamsConstants.APPLICATION_TYPE_LABEL;
    zoneLabel = ViewApplicationDetailsTpamsConstants.ZONE_LABEL;
    descriptionLabel = ViewApplicationDetailsTpamsConstants.DESCRIPTION_LABEL;
    amendmentSchemeNumberLabel = ViewApplicationDetailsTpamsConstants.AMENDMENT_SCHEME_NUMBER_LABEL;
    previousReferenceNumberLabel = ViewApplicationDetailsTpamsConstants.PREVIOUS_REFERENCE_NUMBER_LABEL;
    isResubmissionLabel = ViewApplicationDetailsTpamsConstants.IS_RESUBMISSION_LABEL;
    applicationTypes = [];
    zones = [];
    rezoneConfirmationControlName = ViewApplicationDetailsTpamsConstants.REZONING_APPLICATION_CONFIRMATION_CONTROL_NAME;
    rezoneConfirmationLabel = ViewApplicationDetailsTpamsConstants.REZONING_APPLICATION_CONFIRMATION_LABEL;
    rezoneKeywordRezone = ViewApplicationDetailsTpamsConstants.REZONING_KEYWORD_REZONE;
    rezoneKeywordRezoning = ViewApplicationDetailsTpamsConstants.REZONING_KEYWORD_REZONING;
    isRezoning = false;
    rezoningChecked = false;
    disableDetailsEditing = false;
    applicationTypesControl;
    applicationTypeLimit = ViewApplicationDetailsTpamsConstants.UNLIMITED_APPLICATION_TYPE_LIMIT;
    applicationTypeLimitUiState = mapTpApplicationTypeLimitToUiState(this.applicationTypeLimit, 0);
    supportResubmissions = false;
    isResubmission = false;
    selectedApplicationSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appControllerService, appController, townPlanningService, changeDetectorRef, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.appController = appController;
        this.townPlanningService = townPlanningService;
        this.changeDetectorRef = changeDetectorRef;
        this.routerParamsService = routerParamsService;
        this.listenForRouteParamChange();
    }
    ngOnInit() {
        this.initForm();
        this.loadApplicationTypeLimit();
        this.updateApplicationTypeLimitUiState();
        this.syncRezoningStateWithSelection();
        this.getLookups();
        if (this.appController.moduleAllowResubmission) {
            this.supportResubmissions = true;
        }
    }
    loadMetadata(stepMeta) {
    }
    handleRouteChange() {
    }
    getApplicationTypes() {
        return this.detailsForm.get("applicationTypes");
    }
    getZones() {
        return this.detailsForm.get("zones");
    }
    onBtnRemoveZoneClicked(i) {
        const controls = this.getZones();
        if (controls.controls.length > 1) {
            controls.removeAt(i);
        }
    }
    onBtnAddZoneClicked() {
        const zonesControl = this.getZones();
        const zoneGroup = new FormGroup({
            zone: new FormControl(null)
        });
        zonesControl.push(zoneGroup);
    }
    onRezoningChecked(event) {
        if (this.disableDetailsEditing) {
            return;
        }
        const element = event.target.checked;
        this.rezoningChecked = element;
        const zonesControl = this.getZones();
        if (this.rezoningChecked) {
            if (zonesControl.length === 0) {
                this.onBtnAddZoneClicked();
            }
            zonesControl.enable();
            return;
        }
        zonesControl.clear();
        zonesControl.disable();
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID} and (name eq 'ApplicationType' or name eq 'Zoning')`,
        };
        this.applicationViewService.getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        this.applicationTypes = [];
        this.zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    this.applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === "Zoning") {
                    this.zones.push(JSON.parse(item.content));
                }
            });
            this.changeDetectorRef.markForCheck();
            this.subscribeToSelectedApplication();
        }
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        this.detailsForm.get(this.amendmentSchemeNumberFormControlName).setValue(application.amendmentSchemeNumber);
        this.detailsForm.get(this.amendmentSchemeNumberFormControlName).disable();
        this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        this.detailsForm.get(this.descriptionFormControlName).disable();
        this.detailsForm.get(this.isResubmissionFormControlName).setValue(application.isResubmission);
        this.detailsForm.get(this.isResubmissionFormControlName).disable();
        this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(application.previousReferenceNumber);
        this.detailsForm.get(this.previousReferenceNumberFormControlName).disable();
        if (application.isResubmission) {
            this.isResubmission = application.isResubmission;
        }
        const appTypes = application.applicationTypes || [];
        this.setTypes(appTypes);
        this.updateApplicationTypeLimitUiState();
        const appZones = application.applicationZonings || [];
        this.setZones(appZones);
        this.syncRezoningStateWithSelection();
        this.disableDetailsControls();
    }
    setTypes(appTypes) {
        const typesControl = this.getApplicationTypes();
        typesControl.clear();
        const persistedApplicationTypes = this.getPersistedApplicationTypes(appTypes);
        persistedApplicationTypes.forEach(applicationType => {
            const appType = this.findApplicationTypeLookupOption(applicationType.applicationType);
            const typeGroup = new FormGroup({
                id: new FormControl(applicationType.id),
                applicationId: new FormControl(applicationType.applicationId),
                type: new FormControl({ value: appType, disabled: true })
            });
            typesControl.push(typeGroup);
            typesControl.disable();
        });
        this.updateApplicationTypeLimitUiState();
    }
    setZones(appZones) {
        const zonesControl = this.getZones();
        zonesControl.clear();
        appZones.forEach(applicationZoning => {
            let zone = null;
            this.zones.forEach(item => {
                if (item?.value === applicationZoning.zoning) {
                    zone = item;
                }
            });
            const zoneGroup = new FormGroup({
                id: new FormControl(applicationZoning.id),
                applicationId: new FormControl(applicationZoning.applicationId),
                applicationPropertyId: new FormControl(applicationZoning.applicationPropertyId),
                zone: new FormControl({ value: zone, disabled: true })
            });
            zonesControl.push(zoneGroup);
        });
    }
    onApplicationTypeSelected(index) {
        if (this.disableDetailsEditing) {
            return;
        }
        const duplicateSelectionFound = this.clearControlSelectionIfDuplicate(this.getApplicationTypes(), this.applicationTypeFormControlName, index, ViewApplicationDetailsTpamsConstants.DUPLICATE_APPLICATION_TYPE_WARNING_MESSAGE);
        if (duplicateSelectionFound) {
            this.syncRezoningStateWithSelection();
            return;
        }
        this.syncRezoningStateWithSelection();
    }
    onZoneSelected(index) {
        if (this.disableDetailsEditing) {
            return;
        }
        this.clearControlSelectionIfDuplicate(this.getZones(), this.zoneFormControlName, index, ViewApplicationDetailsTpamsConstants.DUPLICATE_ZONE_WARNING_MESSAGE);
    }
    clearControlSelectionIfDuplicate(controls, controlName, selectedIndex, warningMessage) {
        const selectedControl = controls.at(selectedIndex);
        const selectedValue = this.getLookupValue(selectedControl.get(controlName)?.value);
        if (!selectedValue) {
            return false;
        }
        const duplicateSelectionExists = controls.controls.some((control, index) => {
            if (index === selectedIndex) {
                return false;
            }
            const currentValue = this.getLookupValue(control.get(controlName)?.value);
            return currentValue?.toLowerCase() === selectedValue.toLowerCase();
        });
        if (!duplicateSelectionExists) {
            return false;
        }
        selectedControl.get(controlName).setValue(null);
        this.appControllerService.showMessage(warningMessage, AlertType.Warning);
        return true;
    }
    syncRezoningStateWithSelection() {
        this.isRezoning = this.hasSelectedRezoningApplicationType();
        const zonesControl = this.getZones();
        if (!this.isRezoning) {
            this.rezoningChecked = false;
            zonesControl.clear();
            zonesControl.disable();
            return;
        }
        const hasVisibleZoneRows = zonesControl.length > 0 && zonesControl.enabled;
        this.rezoningChecked = this.hasSelectedZoneValue() || hasVisibleZoneRows;
        if (this.rezoningChecked) {
            if (zonesControl.length === 0) {
                this.onBtnAddZoneClicked();
            }
            zonesControl.enable();
            return;
        }
        zonesControl.clear();
        zonesControl.disable();
    }
    hasSelectedRezoningApplicationType() {
        const typeControls = this.getApplicationTypes();
        return typeControls.controls.some(control => {
            const selectedType = this.getLookupValue(control.get(this.applicationTypeFormControlName)?.value);
            if (!selectedType) {
                return false;
            }
            const typeValue = selectedType.toLowerCase();
            return typeValue.includes(this.rezoneKeywordRezone) || typeValue.includes(this.rezoneKeywordRezoning);
        });
    }
    hasSelectedZoneValue() {
        const zonesControl = this.getZones();
        return zonesControl.controls.some(control => {
            const selectedZone = this.getLookupValue(control.get(this.zoneFormControlName)?.value);
            return !!selectedZone;
        });
    }
    getLookupValue(value) {
        if (!value) {
            return null;
        }
        if (typeof value === "string") {
            return value;
        }
        if (typeof value.value === "string") {
            return value.value;
        }
        return null;
    }
    disableDetailsControls() {
        this.disableDetailsEditing = true;
        this.detailsForm.disable({ emitEvent: false });
    }
    loadApplicationTypeLimit() {
        const moduleId = this.getCurrentModuleIdForLimit();
        this.townPlanningService.getApplicationTypeLimitObservable(moduleId).subscribe((applicationTypeLimit) => {
            this.applicationTypeLimit = normalizeTpApplicationTypeLimit(applicationTypeLimit);
            this.updateApplicationTypeLimitUiState();
            this.changeDetectorRef.markForCheck();
        });
    }
    ensureApplicationTypeDropdownIsVisible() {
        const applicationTypeControls = this.getApplicationTypes();
        if (applicationTypeControls.length > 0) {
            return;
        }
        const typeGroup = new FormGroup({
            id: new FormControl(0),
            applicationId: new FormControl(0),
            type: new FormControl({ value: null, disabled: true })
        });
        applicationTypeControls.push(typeGroup);
        applicationTypeControls.disable({ emitEvent: false });
    }
    updateApplicationTypeLimitUiState() {
        if (!this.detailsForm) {
            return;
        }
        const currentVisibleControlCount = this.getApplicationTypeControlCountForLimit();
        this.applicationTypeLimitUiState = mapTpApplicationTypeLimitToUiState(this.applicationTypeLimit, currentVisibleControlCount);
        if (this.applicationTypeLimitUiState.fullWidthDropdown) {
            this.ensureApplicationTypeDropdownIsVisible();
        }
    }
    getCurrentModuleIdForLimit() {
        const routeModuleId = Number(this.moduleId);
        if (Number.isFinite(routeModuleId) && routeModuleId > 0) {
            return routeModuleId;
        }
        const selectedModuleId = Number(this.appControllerService.selectedModuleID);
        if (Number.isFinite(selectedModuleId) && selectedModuleId > 0) {
            return selectedModuleId;
        }
        return 0;
    }
    getApplicationTypeControlCountForLimit() {
        return this.getApplicationTypes().length;
    }
    getPersistedApplicationTypes(applicationTypes) {
        if (!Array.isArray(applicationTypes) || applicationTypes.length === 0) {
            return [];
        }
        return applicationTypes.filter((applicationType) => this.hasNonEmptyText(applicationType?.applicationType));
    }
    findApplicationTypeLookupOption(applicationTypeValue) {
        const matchingLookup = this.applicationTypes.find((lookupItem) => lookupItem.value === applicationTypeValue);
        return matchingLookup ?? null;
    }
    hasNonEmptyText(value) {
        if (typeof value !== "string") {
            return false;
        }
        return value.trim().length > 0;
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: AppControllerService },
        { type: TownplanningService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsTpamsComponent = __decorate([
    Component({
        selector: "app-view-application-details-tpams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsTpamsComponent);
export { ViewApplicationDetailsTpamsComponent };
